import { render, staticRenderFns } from "./zFiltroAlfabetico.vue?vue&type=template&id=0abb051a&scoped=true&"
import script from "./zFiltroAlfabetico.vue?vue&type=script&lang=js&"
export * from "./zFiltroAlfabetico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb051a",
  null
  
)

export default component.exports